import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const ResetPassword = () => {
  const location = useLocation(); // useLocation으로 전달된 state 접근
  const { userId } = location.state || {}; // userId 가져오기
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(null);

  // 비밀번호 재설정 요청
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userId) {
      setError("유효하지 않은 요청입니다. 다시 시도해주세요.");
      return;
    }

    if (password !== passwordConfirm) {
      setError("비밀번호가 일치하지 않습니다.");
      return;
    }

    try {
      const response = await axios.post(
        "http://35.192.131.111/user/password/",
        {
          user_id: userId,
          password,
          password_confirm: passwordConfirm,
        }
      );

      if (response.data.result) {
        setMessage("비밀번호가 성공적으로 재설정되었습니다.");
        setError(null);
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError("비밀번호 재설정에 실패했습니다.");
    }
  };

  return (
    <div className="reset-password">
      <h2>새 비밀번호 설정</h2>
      {error && <p className="error-message">{error}</p>}
      {message && <p className="message">{message}</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>새 비밀번호</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="새 비밀번호를 입력하세요"
            required
          />
        </div>

        <div className="form-group">
          <label>비밀번호 확인</label>
          <input
            type="password"
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            placeholder="비밀번호를 다시 입력하세요"
            required
          />
        </div>

        <button type="submit">비밀번호 재설정</button>
      </form>
    </div>
  );
};

export default ResetPassword;
